<!--
  이벤트 메뉴(퀵메뉴) UI 컴포넌트
-->
<template>
  <div
    v-show="eventMenuList !== null"
    :class="[classes, {'wide' : eventMenuList.length > 10}]"
  >
    <div class="inner">

      <!-- 이벤트 메뉴 리스트 -->
      <ul class="list">
        <li
          v-for="(item, index) in eventMenuList"
          :key="index"
        >
          <a
            :href="item.link"
            class="link_event_menu"
          >
            <span
              :style="`background-image:url(${item.icon})`"
              class="icon"
            />
            <span class="title" v-html="item.name" />
          </a>
        </li>
      </ul>
      <!-- // 이벤트 메뉴 리스트 -->

    </div>

    <!-- 이벤트 리스트 펼침 버튼 -->
    <button
      ref="eventMenuBtn"
      type="button"
      class="btn_event_menu"
    >주요 카테고리 펼쳐 보기</button>
    <!-- // 이벤트 리스트 펼침 버튼 -->
  </div>
</template>

<script>
export default {
  name: 'CompEventMenu',
  props: {
    classes: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      // 아이콘 메뉴 데이터
      eventMenuList: {}
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate () {

  },
  created () {

  },
  beforeMount () {

  },
  mounted () {
    this.getEventMenuList()
  },
  beforeUpdate () {

  },
  updated () {

  },
  beforeDestroy () {

  },
  methods: {
    getEventMenuList () {
      this.$nextTick(() => {
        let result
        // NOTE: 데이터 처리

        // 샘플 리스트
        result = [
          {
            name: '국비지원',
            icon: '/static/images/@temp/event_icon_01.png',
            link: 'javascript:void(0)'
          },
          {
            name: 'S24<br>주인공은?',
            icon: '/static/images/@temp/event_icon_02.png',
            link: 'javascript:void(0)'
          },
          {
            name: 'LLM',
            icon: '/static/images/@temp/event_icon_03.png',
            link: 'javascript:void(0)'
          },
          {
            name: '프론트엔드',
            icon: '/static/images/@temp/event_icon_04.png',
            link: 'javascript:void(0)'
          },
          {
            name: '백엔드',
            icon: '/static/images/@temp/event_icon_05.png',
            link: 'javascript:void(0)'
          },
          {
            name: 'OutLoud',
            icon: '/static/images/@temp/event_icon_06.png',
            link: 'javascript:void(0)'
          },
          {
            name: '클라우드',
            icon: '/static/images/@temp/event_icon_07.png',
            link: 'javascript:void(0)'
          },
          {
            name: '파이썬',
            icon: '/static/images/@temp/event_icon_08.png',
            link: 'javascript:void(0)'
          },
          {
            name: '외국어',
            icon: '/static/images/@temp/event_icon_09.png',
            link: 'javascript:void(0)'
          },
          {
            name: '비전공자 특화 개발 코스',
            icon: '/static/images/@temp/event_icon_10.png',
            link: 'javascript:void(0)'
          },
          {
            name: '국비지원',
            icon: '/static/images/@temp/event_icon_01.png',
            link: 'javascript:void(0)'
          },
          {
            name: 'S24<br>주인공은?',
            icon: '/static/images/@temp/event_icon_02.png',
            link: 'javascript:void(0)'
          },
          {
            name: 'LLM',
            icon: '/static/images/@temp/event_icon_03.png',
            link: 'javascript:void(0)'
          },
          {
            name: '프론트엔드',
            icon: '/static/images/@temp/event_icon_04.png',
            link: 'javascript:void(0)'
          }
        ]

        this.eventMenuList = result

        // header 데이터 업데이트
        if (this.$parent.$data.hasEventMenu) {
          this.$parent.$data.hasEventMenu = true
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/nrw/portlet/CompEventMenuMo.vue